export default "__VITE_ASSET__DIxvPx9O__"